import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function CanonicalTag() {
const location = useLocation();

useEffect(() => {
let canonical = document.querySelector('link[rel="canonical"]');


if (!canonical) {
  canonical = document.createElement("link");
  canonical.rel = "canonical";
  document.head.appendChild(canonical);
}

canonical.href =
  window.location.origin + location.pathname;


}, [location.pathname]);

return null;
}

export default CanonicalTag;
